import React, { FC, useEffect, useState } from 'react';
import Authoriser from './authoriser';
import Authorised from './authorised';
import Swagger from './swagger';
import { SwaggerContext } from './swaggerContext';
import * as PortalApi from '../../lib/portal-api';

interface AuthorisedSwaggerUIProps {
  version: string;
  operation?: string;
}

const AuthorisedSwaggerUI: FC<AuthorisedSwaggerUIProps> = ({
  version,
  operation,
}) => {
  const [systemConfig, updateSystemConfig] =
    useState<PortalApi.SystemConfigViewModel>({
      authenticationAuthority: '',
      liveDocsApiEndPoints: {
        primary: '',
        sandbox: '',
      },
    });
  useEffect(() => {
    const fetchSwaggerConfig = async () => {
      const config = await PortalApi.getConfig();
      updateSystemConfig(config);
    };
    fetchSwaggerConfig();
  }, [version, operation]);

  return (
    <div>
      <SwaggerContext.Consumer>
        {(swaggerContext) => (
          <>
            {swaggerContext.isAuthenticated ? (
              <Authorised swaggerContext={swaggerContext} />
            ) : (
              <Authoriser
                swaggerContext={swaggerContext}
                systemConfig={systemConfig}
              />
            )}
            {swaggerContext.availableOperations.length > 0 || operation ? (
              <Swagger
                version={version}
                operation={operation}
                swaggerContext={swaggerContext}
                systemConfig={systemConfig}
              />
            ) : (
              <p>
                Try the API by choosing a project that has at least one API
                package enabled.
              </p>
            )}
          </>
        )}
      </SwaggerContext.Consumer>
    </div>
  );
};

export default AuthorisedSwaggerUI;
